import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SyncErrorService {

  constructor(private http: HttpClient) { }

  getSyncErrorList(requestData:RequestData): Observable<any> {
      return this.http.post(environment.baseUrl+'/sync-queue/get', requestData);
  
    }
}
